const styles = {
  inputStyles: {
    marginBottom: 8,
    display: 'block'
  }
}
export { styles }
